export default "__VITE_ASSET__CrOQ3150__"